(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("configurePointSystem", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/gamification/configurePointSystemView.html",
            controller: ["gamificationResource", "$translate", "messageService", "frameworkService", "$state", "_", ConfigurePointSystemCtrl],
            controllerAs: "vm"
        };
        function ConfigurePointSystemCtrl(gamificationResource, $translate, messageService, frameworkService, $state, _) {
            var vm = this;
            vm.loading = true;
            vm.collapse = {};
            if (!frameworkService.data.tenantFeatures.gamificationPointSystem)
                $state.go("main.notFound");
            gamificationResource.getPointSystemViewModel(function (data) {
                vm.settings = _.groupBy(data.settings, function (setting) {
                    var category = $translate.instant("gamification.pointSystem.category." + setting.category);
                    vm.collapse[category] = false;
                    return category;
                });
                vm.loading = false;
            });
            /////////////////////////////////////////////////////////////////
            vm.enable = function (setting) {
                gamificationResource.enablePointSystemSetting({ id: setting.id }, function () {
                    setting.enabled = true;
                    messageService.success("gamification.pointSystem.settingEnabled.success");
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.disable = function (setting) {
                gamificationResource.disablePointSystemSetting({ id: setting.id }, function () {
                    setting.enabled = false;
                    messageService.success("gamification.pointSystem.settingDisabled.success");
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.validateAndSave = function (data, setting) {
                if (data < 0 || data > 1000)
                    return $translate.instant("gamification.pointSystem.editPoints.error.pointLimits");
                else if (!parseInt(data))
                    return $translate.instant("gamification.pointSystem.editPoints.error.pointsRequired");
                else {
                    gamificationResource.editPointSystem({ id: setting.id, points: data }, function () {
                        //all is good, update the model
                        setting.points = data;
                        messageService.success("gamification.pointSystem.editPoints.success");
                        //Async update all the history points updateAcingExamPointsForAllLearners
                        gamificationResource.updateAcingExamPointsForAllLearners({ points: data }, function () {
                        }, function (error) {
                            messageService.error(error);
                        });
                    }, function (error) {
                        messageService.error(error);
                    });
                }
                return false; //close the edit box without updating the model
            };
            vm.clearErrors = function (form) {
                form.$setError("setting.points", "");
            };
        }
    });
})();
